import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { addBankQuestion } from '.';

export function useAddBankQuestion(){
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: queryKeys.question_bank._def,
        mutationFn: addBankQuestion,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.question_bank._def, exact: false });
        }
    });
}
